import React from 'react';
import AboutUsBanner from '../components/AboutUsBanner';
import BusinessGrowthComponent from '../components/AboutUsDetail';
import ExpertAdviceSection from '../components/AboutUsDetail2';
import TalentSection from '../components/TalentSection';
import InnovativeFooter from '../components/Footer';
import IconTree from '../components/IconTree'
import AboutBanner from '../components/AboutBanner';
import ConsultationComponent from '../components/ConsultationComponent';
function HomePage() {
  return (
    <>
       <AboutBanner />
      {/* {/* <AboutUsBanner /> */}
      <BusinessGrowthComponent /> 
      <IconTree />
      <ExpertAdviceSection />
      {/* <ConsultationComponent /> */}
      {/* <TalentSection /> */}
     
      {/* <InnovativeFooter /> */}


    </>
  );
}

export default HomePage;